<template>
  <div class="landing-page-container">
    <div
      class="before-chat-call-to-action"
      :style="settings_before_chat.page_background"
    >
      <div class="logo" v-if="settings_before_chat.logo">
        <img :src="settings_before_chat.logo" alt="Logo Bot" title="Logo Bot" />
      </div>

      <h4 class="title" :style="settings_before_chat.text_settings">
        {{ settings_before_chat.title }}
      </h4>

      <p class="description" :style="settings_before_chat.text_settings">
        {{ settings_before_chat.description }}
      </p>

      <div class="row links">
        <div class="col" v-for="(link, index) in links" :key="index">
          <a
            :href="link.url"
            :style="{ color: botStyleConfig.color }"
            target="_blak"
            rel="noopener noreferrer"
          >
            <font-awesome-icon
              class="icon-link"
              :icon="['fab', `${link.name}`]"
              v-if="link.name !== 'link'"
            />
            <font-awesome-icon class="icon-link" :icon="['fas', `${link.name}`]" v-else />
          </a>
        </div>
      </div>

      <button
        class="call-to-action"
        :style="settings_before_chat.button_settings"
        @click="handleStartConversation"
      >
        {{ settings_before_chat.starting_text }}
      </button>
    </div>
  </div>
</template>

<script>
import { DEFAULT_BOT_AVATAR_URL } from "@/constants";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faYoutube,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faFacebookF,
  faGithub,
  faTwitter,
  faTiktok,
  faSpotify,
  faTelegram,
} from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";

library.add(
  faYoutube,
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faLink,
  faGithub,
  faFacebookF,
  faTwitter,
  faTiktok,
  faSpotify,
  faTelegram
);

export default {
  name: "BeforeChatCallToAction",
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {};
  },
  props: {
    settings_before_chat: {
      type: [Object, Boolean],
      required: false,
      default: () => {
        return {
          title: "Olá, eu sou o NEORON!",
          description:
            "Sou a Inteligência Artificial que \ncriada pela FABWORK para \nfacilitar a criação de chatbots",
          starting_text: "Iniciar conversa!",
          page_background: {
            background:
              "linear-gradient(0deg, #FFFFFF, #F3FADD, #ACC1DB, #44709D, #114585)",
          },
          logo: "",
          button_settings: {
            background: "#e4e47b",
            color: "#114585",
          },
          text_settings: {
            color: "#114585",
          },
        };
      },
    },
    handleStartConversation: {
      type: Function,
      required: true,
      default: () => {},
    },
    links: {
      type: Array,
      require: false,
    },
    botStyleConfig: {
      type: Object,
      required: false,
    },
  },
  components: {
    FontAwesomeIcon,
  },
  computed: {},
  methods: {},
  filters: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.landing-page-container {
  min-height: 100vh;
  height: 100vh;
}

.before-chat-call-to-action {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  text-align: center;
  align-items: center;

  .links {
    display: flex;
    justify-content: center;
    .col {
      width: 45px;
      max-width: 45px;

      a {
        .icon-link{
          height: 15px;
        }
        
        font-size: 10px;
      }
    }
  }

  .logo {
    margin: 15px 0 25px;
    img {
      max-width: 265px;
      max-height: 150px;

      @media screen and (max-width: 500px) {
        max-width: 150px;
        max-height: 100px;
      }
    }
  }

  .title {

    width: 90%;

    @media screen and (max-width: 500px) {
      max-width: 215px;
      font-size: 23px;
    }
  }

  .description {
    margin: 15px auto;
    max-width: 275px;
    font-size: 8pt;
    text-align: center;
    word-wrap: break-word;

    @media screen and (max-width: 800px) {
      max-width: 275px;
      font-size: 16px;
      margin: 15px;
    }

    @media screen and (max-width: 500px) {
      max-width: 215px;
      font-size: 14px;
      margin: 15px 25px;
    }
  }

  .call-to-action {
    margin: 20px auto 15px;
    width: 100%;
    max-width: 275px;
    padding: 10px 25px;
    outline: transparent;
    border: transparent;
    font-size: 18px;
    font-weight: 600;
    box-shadow: 0 5px 13px #80808096;
    cursor: pointer;

    @media screen and (max-width: 500px) {
      max-width: 215px;
      font-size: 14px;
      margin: 15px;
    }

    &:hover {
      opacity: 0.8;
    }
    &:focus {
      filter: brightness(0.95);
    }
  }
}
</style>
